/* KORA · Selvática — test "Descubre tu ritual" */
(function(){
  const root=document.querySelector('[data-selv-quiz]'); if(!root) return;
  const data=JSON.parse(root.querySelector('script[type="application/json"]').textContent);
  const steps=[...root.querySelectorAll('.selv-quiz__step')];
  const bar=root.querySelector('.selv-quiz__bar i');
  const result=root.querySelector('[data-result]');
  let i=0; const score={LU:0,RM:0,FS:0}; const ans={};
  function show(n){
    i=n; steps.forEach((s,k)=>s.classList.toggle('is-active',k===n));
    bar.style.width=((n+1)/(steps.length+1)*100)+'%';
    root.scrollIntoView({behavior:'smooth',block:'start'});
  }
  function pick(btn){
    const step=btn.closest('.selv-quiz__step'); const multi=btn.hasAttribute('data-multi');
    if(!multi){ step.querySelectorAll('.selv-quiz__opt').forEach(b=>b.classList.remove('is-on')); }
    btn.classList.toggle('is-on');
    const alert=step.querySelector('.selv-quiz__alert');
    if(alert){ const a=btn.dataset.alert; alert.innerHTML=a||''; alert.classList.toggle('is-on',!!a && btn.classList.contains('is-on')); }
    if(!multi && !btn.dataset.stop){ setTimeout(()=>next(),350); }
    if(btn.dataset.stop && btn.classList.contains('is-on')){ step.querySelector('[data-next]').style.display='none'; }
    else if(step.querySelector('[data-next]')){ step.querySelector('[data-next]').style.display=''; }
  }
  function next(){
    const step=steps[i]; const on=[...step.querySelectorAll('.selv-quiz__opt.is-on')];
    on.forEach(b=>{ (b.dataset.score||'').split(',').filter(Boolean).forEach(p=>{const [k,v]=p.split(':'); score[k]+=+v;}); if(b.dataset.key) ans[b.dataset.key]=b.dataset.val||b.textContent.trim(); });
    let n=i+1;
    while(n<steps.length && steps[n].dataset.if && !evalIf(steps[n].dataset.if)) n++;
    if(n>=steps.length) return finish();
    show(n);
  }
  function evalIf(c){ if(c==='FS') return score.FS>0; return true; }
  function finish(){
    const order=Object.entries(score).sort((a,b)=>b[1]-a[1]);
    let win=order[0][1]>0?order[0][0]:'LU'; const tie=order[0][1]>0 && order[1][1]>0?order[1][0]:null;
    const p=data.products[win]; const second=tie?data.products[tie]:null;
    const reasons=(data.reasons[win]||[]).slice(0,3);
    const emb=ans.embarazo==='si';
    steps.forEach(s=>s.classList.remove('is-active')); bar.style.width='100%';
    result.style.setProperty('--c',p.color);
    result.innerHTML=`
      <div class="selv-result__img">${second?`<div class="selv-result__pair"><img src="${p.image}" alt="${p.title}"><img src="${second.image}" alt="${second.title}" style="border-bottom:6px solid ${second.color}"></div>`:`<img src="${p.image}" alt="${p.title}">`}</div>
      <div>
        <span class="selv-result__tag">${second?'Tus rituales Selváticos':'Tu ritual Selvático'}</span>
        <h2>${p.title}</h2>
        <p>${p.text}${emb?' '+data.embarazoTxt:''}</p>
        <ul>${reasons.map(r=>`<li>${r}</li>`).join('')}</ul>
        <p class="selv-result__price">${p.price} <small style="font-size:.9rem;opacity:.7">· 50 g · hasta 20 sesiones</small></p>
        ${second?`<div class="selv-result__duo" style="--c2:${second.color}"><span class="selv-result__tag" style="color:${second.color}">Y también</span><h3>${second.title}</h3><p>Como tienes síntomas de las dos, puedes intercalarlas: <b>3 noches con una y 3 noches con la otra</b>.</p><p class="selv-result__price" style="font-size:1.4rem">${second.price}</p></div>`:''}
        <div class="selv-btns">${second?`<button class="selv-btn" data-add="${p.variant}" data-add2="${second.variant}">Añadir las dos a mi carrito</button><button class="selv-btn selv-btn--ghost" data-add="${p.variant}">Solo ${p.title}</button>`:`<button class="selv-btn" data-add="${p.variant}">Añadir a mi carrito</button><a class="selv-btn selv-btn--ghost" href="${p.url}">Ver la mezcla</a>`}</div>
        ${data.med?`<div class="selv-result__extra"><label><input type="checkbox" data-med="${data.med.variant}" checked> Añadir la meditación <b>${data.med.title}</b> (+${data.med.price})</label></div>`:''}
      </div>`;
    result.scrollIntoView({behavior:'smooth',block:'start'});
  }
  root.addEventListener('click',e=>{
    const opt=e.target.closest('.selv-quiz__opt'); if(opt) return pick(opt);
    if(e.target.closest('[data-next]')) return next();
    if(e.target.closest('[data-back]')) return show(Math.max(0,i-1));
    const add=e.target.closest('[data-add]'); if(add) return addToCart(add);
  });
  async function addToCart(btn){
    btn.disabled=true; btn.textContent='Añadiendo…';
    const items=[{id:+btn.dataset.add,quantity:1}]; if(btn.dataset.add2) items.push({id:+btn.dataset.add2,quantity:1});
    const med=result.querySelector('[data-med]'); if(med&&med.checked) items.push({id:+med.dataset.med,quantity:1});
    try{ const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})}); if(!r.ok) throw 0; window.location.href='/cart'; }
    catch(e){ btn.disabled=false; btn.textContent='Inténtalo de nuevo'; }
  }
  show(0);
})();

/* KORA · Selvática — upsell meditación en carrito */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-selv-upsell]'); if (!btn) return;
  btn.disabled = true; btn.textContent = '…';
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.dataset.selvUpsell, quantity: 1 }] }) });
    if (!r.ok) throw 0;
    const cart = await (await fetch('/cart.js')).json();
    try { const { CartAddEvent } = await import('@theme/events'); document.dispatchEvent(new CartAddEvent(cart, 'kora-selv-upsell', { itemCount: cart.item_count, source: 'kora-selv-upsell' })); }
    catch (_) { location.reload(); }
  } catch (_) { btn.disabled = false; btn.textContent = 'Añadir'; }
});

/* KORA · Selvática — packs en la ficha */
(function(){
  function qtyInput(){ return document.querySelector('.product-details input[name="quantity"], product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]'); }
  function setQty(n){
    const inp=qtyInput(); if(!inp) return;
    const comp=inp.closest('quantity-selector-component');
    if(comp && typeof comp.setValue==='function'){ try{ comp.setValue(String(n)); }catch(_){ inp.value=n; } } else { inp.value=n; }
    inp.dispatchEvent(new Event('input',{bubbles:true})); inp.dispatchEvent(new Event('change',{bubbles:true}));
  }
  document.addEventListener('click',async e=>{
    const b=e.target.closest('[data-selv-packs] .selv-pack');
    if(b){ b.parentElement.querySelectorAll('.selv-pack').forEach(x=>x.classList.toggle('is-on',x===b)); setQty(+b.dataset.qty); return; }
    const t=e.target.closest('[data-selv-trio]'); if(!t) return;
    t.disabled=true; const old=t.textContent; t.textContent='…';
    try{
      const items=t.dataset.selvTrio.split(',').filter(Boolean).map(id=>({id:+id,quantity:1}));
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})}); if(!r.ok) throw 0;
      const cart=await (await fetch('/cart.js')).json();
      try{ const {CartAddEvent}=await import('@theme/events'); document.dispatchEvent(new CartAddEvent(cart,'kora-selv-trio',{itemCount:cart.item_count,source:'kora-selv-trio'})); }catch(_){ location.href='/cart'; }
      t.textContent='¡Añadidas!'; setTimeout(()=>{t.textContent=old;t.disabled=false;},2500);
    }catch(_){ t.textContent=old; t.disabled=false; }
  });
  document.addEventListener('change',e=>{
    if(!e.target.matches('input[name="quantity"]')) return;
    const box=document.querySelector('[data-selv-packs]'); if(!box) return;
    const n=+e.target.value; box.querySelectorAll('.selv-pack').forEach(x=>x.classList.toggle('is-on',+x.dataset.qty===Math.min(n,3)));
  });
})();

/* KORA · Selvática — cuenta atrás Black Friday */
(function(){
  document.querySelectorAll('[data-selv-hasta]').forEach(function(el){
    var fin=new Date(el.dataset.selvHasta+'T23:59:59+01:00').getTime();
    function tick(){ var r=Math.max(0,fin-Date.now()); var d=Math.floor(r/864e5),h=Math.floor(r%864e5/36e5),m=Math.floor(r%36e5/6e4),s=Math.floor(r%6e4/1e3);
      el.querySelector('[data-d]').textContent=d; el.querySelector('[data-h]').textContent=h; el.querySelector('[data-m]').textContent=m; el.querySelector('[data-s]').textContent=s;
      if(r<=0){ var sec=el.closest('.selv-bf'); if(sec) sec.remove(); } }
    tick(); setInterval(tick,1000);
  });
})();

/* KORA · Selvática — upsell Liver Cleanse: cambia una bolsa de vapores por su combo -10 % */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-selv-combo]'); if (!btn) return;
  btn.disabled = true; btn.textContent = '…';
  try {
    const cart0 = await (await fetch('/cart.js')).json();
    const line = cart0.items.find(i => i.key === btn.dataset.quitar);
    if (line) {
      const r1 = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity - 1 }) });
      if (!r1.ok) throw 0;
    }
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.dataset.selvCombo, quantity: 1 }] }) });
    if (!r.ok) throw 0;
    const cart = await (await fetch('/cart.js')).json();
    try { const { CartAddEvent } = await import('@theme/events'); document.dispatchEvent(new CartAddEvent(cart, 'kora-selv-upsell', { itemCount: cart.item_count, source: 'kora-selv-upsell' })); }
    catch (_) { location.reload(); }
  } catch (_) { btn.disabled = false; btn.textContent = 'Añadir'; }
});
